export var RestaurantState;
(function (RestaurantState) {
    RestaurantState["IDLE"] = "IDLE";
    RestaurantState["LOADING"] = "LOADING";
    RestaurantState["COMPLETED"] = "COMPLETED";
    RestaurantState["ERROR"] = "ERROR";
})(RestaurantState || (RestaurantState = {}));
export class RestaurantModel {
    constructor(value, lat, lng, mode) {
        this.value = value;
        this.lat = lat;
        this.lng = lng;
        this.mode = mode;
    }
}
